declare let ExpressionText: any;

declare global {
  interface Window {
    ExpressionText: any;
  }
}

export function extendExpressionText() {
  if (lib.comsuntexsymbolsExpressionText) {
    window.ExpressionText = lib.comsuntexsymbolsExpressionText;

    const comsuntexsymbolsExpressionText_constructor =
      lib.comsuntexsymbolsExpressionText;
    const comsuntexsymbolsExpressionText_prototype =
      lib.comsuntexsymbolsExpressionText.prototype;

    lib.comsuntexsymbolsExpressionText = function () {
      this._oldConstructor = comsuntexsymbolsExpressionText_constructor;
      this._oldConstructor();

      this.fixFont(this.expression);
      this.fixFont(this.expNum);
      this.fixFont(this.expDen);

      this.expression.text = '';
      this.expNum.text = '';
      this.expDen.text = '';
      UIUtil.find(this, 'line').alpha = 0.0;

      UIUtil.disable(this);
    };
    lib.comsuntexsymbolsExpressionText.prototype =
      comsuntexsymbolsExpressionText_prototype;

    const p = lib.comsuntexsymbolsExpressionText.prototype;

    p.fixFont = function (textField) {
      textField.font = textField.font
        .replace('Arial', 'Suntex')
        .replace('Tahoma', 'Suntex');
    };

    p.clear = function () {
      UIUtil.htmlText(this.expNum, '');
      UIUtil.htmlText(this.expDen, '');
      UIUtil.htmlText(this.expression, '');

      this.expNum._htmlText.style.whiteSpace = 'nowrap';
      this.expDen._htmlText.style.whiteSpace = 'nowrap';
      this.expression._htmlText.style.whiteSpace = 'nowrap';
    };

    p.displayExpression = function (expression) {
      this.clear();
      if (Calculator.isFraction(expression)) {
        UIUtil.htmlText(
          this.expNum,
          ExpressionText.formatExpression(expression[0]),
        );
        UIUtil.htmlText(
          this.expDen,
          ExpressionText.formatExpression(expression[1]),
        );
        UIUtil.find(this, 'line').alpha = 1.0;
      } else {
        UIUtil.htmlText(
          this.expression,
          ExpressionText.formatExpression(expression),
        );
        UIUtil.find(this, 'line').alpha = 0.0;
      }
    };

    //Static
    ExpressionText.formatExpression = function (expression) {
      const size = Math.floor(
        32 - ExpressionText.getStringLength(expression) * 0.8,
      );
      const topOffset = (30 - size) / 2;
      expression =
        '<span style=\"font-size:' +
        size +
        'px; position: relative; top: ' +
        topOffset +
        'px;\">' +
        expression +
        '</span>';
      return expression;
    };

    ExpressionText.getStringLength = function (str) {
      return str.length - str.replace(/[^\(\)\[\]]/g, '').length / 2;
    };
  }
}
